import { TournamentLocationTypes } from 'common';

import { InjectableHook } from 'domain/hooks';

export const TournamentLocationsRepository = Symbol('TournamentLocationsRepository');

export type ITournamentLocationsRepository = InjectableHook<{
  fetchTournamentLocations(): Promise<TournamentLocationTypes.TournamentLocationResponse[]>;
}>;
